import axios from "./axiosInstance";

const enquiryFormAPI = {
  enquiry_form: (payload) => axios.post("enquire_form", payload),
};

export default enquiryFormAPI;
